import { DecisionMode } from './DecisionMode';
import { FlagshipConfig } from './FlagshipConfig';
export class EdgeConfig extends FlagshipConfig {
    constructor(param) {
        super({ ...param, decisionMode: DecisionMode.BUCKETING_EDGE });
    }
}
